(function () {
  if (window.__aurenPackCartBound) return;
  window.__aurenPackCartBound = true;

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('quantity-input[data-auren-pack-quantity] button[name]');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var picker = button.closest('quantity-input[data-auren-pack-quantity]');
    var input = picker && picker.querySelector('input[name="updates[]"]');
    if (!input || picker.dataset.aurenUpdating === 'true') return;

    var current = Number(input.value) || 2;
    var next = button.name === 'plus' ? current + 2 : current - 2;
    next = Math.max(2, Math.min(6, next));
    if (next === current) return;

    picker.dataset.aurenUpdating = 'true';
    picker.setAttribute('aria-busy', 'true');
    input.value = next;

    try {
      var response = await fetch(window.routes && routes.cart_change_url ? routes.cart_change_url : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(picker.dataset.line), quantity: next })
      });
      if (!response.ok) throw new Error('No se pudo actualizar el pack.');
      window.location.reload();
    } catch (error) {
      input.value = current;
      picker.dataset.aurenUpdating = 'false';
      picker.removeAttribute('aria-busy');
      var errorBox = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errorBox) errorBox.textContent = 'No pudimos actualizar el pack. Inténtalo nuevamente.';
    }
  }, true);
})();
